import { InterpolationWithTheme } from "@emotion/core";



export const consentStyles: { [key: string]: InterpolationWithTheme<any> } = {
    container: {
        display: "flex",
        boxShadow: "0px 2px 14px 0px rgba(0, 0, 0, 0.1)",
        margin: "10px",
        borderRadius: "10px",
        padding: "20px"
    },
    left: {
        flex: 1
    },
    right: {
        flex: 2
    },
    consentTitle: {
        color: "rgb(44, 44, 44)",
        fontFamily: "BrandonTextWeb-Bold",
        fontSize: "20px"
    },
    consentSubTitle: {
        color: "rgb(72, 72, 72)",
        fontFamily: "BrandonTextWeb-Regular",
        fontSize: "16px",
        marginTop: "10px"
    },
    optionTitle: {
        color: "rgb(72, 72, 72)",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: "16px",
        fontWeight: 500,
        marginTop: "10px"
    },
    optionDescription: {
        color: "rgb(72, 72, 72)",
        fontFamily: "BrandonTextWeb-Regular",
        fontSize: "13px",
        fontStyle: "italic"
    },
    consentContainerWrapper: {
        position: "fixed",
        top: "220px",
        left: " 0px",
        width: "100vw",
        height: "calc(100vh - 85px)",
        background: "#ffffff",
        zIndex: 99
    },
    consentQuestion: {
        marginTop: "30px",
        color: "rgb(44, 44, 44)",
        fontFamily: "BrandonTextWeb-Bold",
        fontSize: "18px",
        fontWeight: "bold",
    },
    inputWrapper: {
        display: "flex"
    },
    inputTextWrapper: {
        marginLeft: "10px"
    },
    radio: {
        marginTop: "15px !important"
    },
    button: {
        marginTop: "20px",
        borderRadius: "20px",
        border: "none",
        padding: "10px 25px",
        color: "#ffffff",
        backgroundColor: "#ff2e73"
    },
    yesBtn: {
        marginTop: "20px",
        borderRadius: "20px",
        border: "none",
        padding: "10px 25px",
        color: "#ffffff",
        backgroundColor: "#ff2e73",
        borderWidth: "1px",
        borderColor: "#ff2e73",
        borderStyle: "solid",
        margin: "10px"
    },
    noBtn: {
        marginTop: "20px",
        borderRadius: "20px",
        border: "none",
        padding: "10px 25px",
        color: "#ff2e73",
        backgroundColor: "#ffffff",
        borderWidth: "1px",
        borderColor: "#ff2e73",
        borderStyle: "solid",
        margin: "10px"
    },
    modalCtaContainer: {
        textAlign: "right"
    }
}